import { useState } from 'react';

interface Props {
  onLogin: () => void;
}

const ADMIN_PASSWORD = 'ankara2025';

export default function AdminLogin({ onLogin }: Props) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState(false);
  const [showPass, setShowPass] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === ADMIN_PASSWORD) {
      localStorage.setItem('admin_auth', 'true');
      onLogin();
    } else {
      setError(true);
      setPassword('');
      setTimeout(() => setError(false), 3000);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-orange-50 via-white to-amber-50">
      <div className="w-full max-w-sm">
        <div className="bg-white rounded-2xl border border-gray-100 p-8">
          <div className="text-center mb-8">
            <div className="w-14 h-14 flex items-center justify-center bg-orange-500 rounded-2xl mx-auto mb-4">
              <i className="ri-shield-keyhole-line text-white text-2xl" />
            </div>
            <h1 className="text-xl font-bold text-gray-900">Admin Paneli</h1>
            <p className="text-sm text-gray-500 mt-1">Devam etmek için giriş yapın</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <label className="block text-xs font-medium text-gray-600 mb-1.5">Admin Şifresi</label>
              <div className="relative">
                <input
                  type={showPass ? 'text' : 'password'}
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Şifrenizi girin"
                  required
                  className={`w-full border rounded-xl px-4 py-3 text-sm text-gray-800 focus:outline-none transition-colors pr-10 ${
                    error
                      ? 'border-red-400 bg-red-50 focus:border-red-400'
                      : 'border-gray-200 focus:border-orange-400'
                  }`}
                />
                <button
                  type="button"
                  onClick={() => setShowPass(!showPass)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center text-gray-400 hover:text-gray-600 cursor-pointer"
                >
                  <i className={showPass ? 'ri-eye-off-line' : 'ri-eye-line'} />
                </button>
              </div>
              {error && (
                <p className="text-xs text-red-500 mt-1.5 flex items-center gap-1">
                  <i className="ri-error-warning-line" />
                  Yanlış şifre. Tekrar deneyin.
                </p>
              )}
            </div>

            <button
              type="submit"
              className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-xl text-sm font-semibold transition-colors cursor-pointer whitespace-nowrap"
            >
              Giriş Yap
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-gray-100 text-center">
            <p className="text-xs text-gray-400">
              Bu panel yalnızca yetkili yöneticilere aittir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
